/* ---------------------------------------------------------------------------
 * Designer Plants USA - side cart behavior (window.dpCart)
 * ------------------------------------------------------------------------- */
window.dpCart = window.dpCart || (function () {
  var ADD_URL = (window.routes && window.routes.cartAddUrl) || '/cart/add';

  function refresh() {
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
      bubbles: true,
      detail: { scrollToTop: false }
    }));
  }

  return {
    close: function () {
      var form = document.getElementById('mini-cart');
      if (!form) { return; }
      var toggle = document.querySelector('[aria-controls="mini-cart"]');
      if (toggle) { toggle.click(); return; }
      form.setAttribute('aria-hidden', 'true');
    },

    scroll: function (btn, dir) {
      var wrap = btn.closest('.dp-xs');
      var rail = wrap ? wrap.querySelector('.dp-xs__rail') : null;
      if (!rail) { return; }
      var first = rail.firstElementChild;
      var step = first ? first.getBoundingClientRect().width + 12 : rail.clientWidth;
      rail.scrollBy({ left: dir * step, behavior: 'smooth' });
    },

    add: function (btn) {
      if (btn.disabled) { return; }
      var id = btn.getAttribute('data-variant-id');
      if (!id) { return; }
      var label = btn.textContent;
      var err = btn.parentNode ? btn.parentNode.querySelector('[data-dp-xs-error]') : null;
      if (err) { err.hidden = true; }
      btn.disabled = true;
      btn.textContent = 'Adding';

      fetch(ADD_URL + '.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
      })
        .then(function (r) { if (!r.ok) { throw new Error('add failed'); } return r.json(); })
        .then(function () {
          btn.textContent = 'Added';
          btn.classList.add('is-added');
          refresh();
        })
        .catch(function () {
          btn.disabled = false;
          btn.classList.remove('is-added');
          btn.textContent = label;
          if (err) { err.hidden = false; }
        });
    },

    discount: function (btn) {
      var foot = btn.closest('.dp-foot');
      var input = foot ? foot.querySelector('[data-dp-disc-input]') : null;
      var msg = foot ? foot.querySelector('[data-dp-disc-msg]') : null;
      if (!input) { return; }
      var code = (input.value || '').trim();
      if (!code) { return; }

      var before = 0;
      btn.disabled = true;
      btn.textContent = '...';
      if (msg) { msg.hidden = true; msg.className = 'dp-foot__disc-msg'; }

      fetch('/cart.js', { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (c) {
          before = c.total_price;
          return fetch('/discount/' + encodeURIComponent(code) + '?redirect=/cart.js', {
            credentials: 'same-origin',
            headers: { 'Accept': 'application/json' }
          });
        })
        .then(function (r) { return r.json(); })
        .then(function (c) {
          var applied = (c.discount_applications && c.discount_applications.length > 0) ||
                        (c.total_price < before);
          btn.disabled = false;
          btn.textContent = 'Apply';
          if (msg) {
            msg.hidden = false;
            msg.className = 'dp-foot__disc-msg ' + (applied ? 'is-ok' : 'is-err');
            msg.textContent = applied ? 'Code applied' : 'That code is not valid for this order';
          }
          if (applied) { input.value = ''; refresh(); }
        })
        .catch(function () {
          btn.disabled = false;
          btn.textContent = 'Apply';
          if (msg) {
            msg.hidden = false;
            msg.className = 'dp-foot__disc-msg is-err';
            msg.textContent = 'Could not apply that code. Please try again.';
          }
        });
    }
  };
})();

/* ---------------------------------------------------------------------------
 * Drawer auto-open and per-line savings.
 * The persistent MutationObserver is scoped to the current cart drawer only.
 * When Shopify replaces the drawer after cart:refresh, short re-arm timers find
 * the new drawer and attach a new scoped observer. Nothing watches document.body.
 * ------------------------------------------------------------------------- */
(function () {
  if (window.dpDrawerHook) { return; }
  window.dpDrawerHook = true;

  function isAddUrl(url) {
    try {
      return String(url).indexOf('/cart/add') !== -1;
    } catch (e) { return false; }
  }

  function openDrawer() {
    var form = document.getElementById('mini-cart');
    if (!form) { return; }
    if (form.getAttribute('aria-hidden') === 'false') { return; }
    var toggle = document.querySelector('[aria-controls="mini-cart"]');
    if (toggle) { toggle.click(); }
  }

  function amount(text) {
    var n = parseFloat(String(text).replace(/[^0-9.\-]/g, ''));
    return isNaN(n) ? null : n;
  }
  function symbol(text) {
    var m = String(text).match(/^[^0-9]*/);
    return m ? m[0].trim() : '$';
  }
  function fmt(sym, n) {
    return sym + n.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function markLineSavings() {
    var lists = document.querySelectorAll('.dp-cart .mini-cart__price-list');
    for (var i = 0; i < lists.length; i++) {
      var list = lists[i];
      if (list.querySelector('.dp-line-save')) { continue; }
      var was = list.querySelector('.price--compare');
      if (!was) { continue; }
      var now = null;
      var prices = list.querySelectorAll('.price');
      for (var j = 0; j < prices.length; j++) {
        if (!prices[j].classList.contains('price--compare')) { now = prices[j]; break; }
      }
      if (!now) { continue; }
      var a = amount(was.textContent);
      var b = amount(now.textContent);
      if (a === null || b === null || a <= b) { continue; }
      var tag = document.createElement('span');
      tag.className = 'dp-line-save';
      tag.textContent = 'Save ' + fmt(symbol(was.textContent), a - b);
      was.parentNode.insertBefore(tag, was.nextSibling);
    }
  }

  var cartObserver = null;
  var observedCart = null;
  var rearmTimers = [];
  var savingsTimer = null;

  function armCartObserver() {
    markLineSavings();
    if (!window.MutationObserver) { return; }
    var cart = document.querySelector('.dp-cart');
    if (!cart) { return; }
    if (cart === observedCart && cartObserver) { return; }
    if (cartObserver) { cartObserver.disconnect(); }
    observedCart = cart;
    cartObserver = new MutationObserver(function () {
      clearTimeout(savingsTimer);
      savingsTimer = setTimeout(markLineSavings, 40);
    });
    cartObserver.observe(cart, { childList: true, subtree: true });
  }

  function scheduleCartObserver() {
    for (var i = 0; i < rearmTimers.length; i++) { clearTimeout(rearmTimers[i]); }
    rearmTimers = [];
    armCartObserver();
    [80, 220, 500, 900].forEach(function (delay) {
      rearmTimers.push(setTimeout(armCartObserver, delay));
    });
  }

  function afterAdd() {
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
      bubbles: true,
      detail: { scrollToTop: false }
    }));
    setTimeout(openDrawer, 60);
    setTimeout(openDrawer, 400);
  }

  var nativeFetch = window.fetch;
  if (typeof nativeFetch === 'function') {
    window.fetch = function (input, init) {
      var url = (input && input.url) ? input.url : input;
      var method = (init && init.method) || (input && input.method) || 'GET';
      var watch = isAddUrl(url) && String(method).toUpperCase() === 'POST';
      var out = nativeFetch.apply(this, arguments);
      if (!watch) { return out; }
      return out.then(function (res) {
        if (res && res.ok) { afterAdd(); }
        return res;
      });
    };
  }

  var nativeOpen = XMLHttpRequest.prototype.open;
  var nativeSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (method, url) {
    this.dpWatch = isAddUrl(url) && String(method).toUpperCase() === 'POST';
    return nativeOpen.apply(this, arguments);
  };
  XMLHttpRequest.prototype.send = function () {
    if (this.dpWatch) {
      this.addEventListener('load', function () {
        if (this.status >= 200 && this.status < 300) { afterAdd(); }
      });
    }
    return nativeSend.apply(this, arguments);
  };

  document.documentElement.addEventListener('cart:refresh', scheduleCartObserver);
  document.documentElement.addEventListener('product:added', scheduleCartObserver);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', armCartObserver, { once: true });
  } else {
    armCartObserver();
  }
})();

/**
 * Include your custom JavaScript here.
 */
var coll = document.getElementsByClassName("collaps");
var i;

for (i = 0; i < coll.length; i++) {
  coll[i].addEventListener("click", function() {
    this.classList.toggle("active");
    var content = this.nextElementSibling;
    if (content.style.maxHeight){
      content.style.maxHeight = null;
    } else {
      content.style.maxHeight = content.scrollHeight + "px";
    }
  });
}

const videoElements = document.querySelectorAll("video");
videoElements.forEach(video => {
  video.setAttribute("controlsList", "nodownload");
});

const liquidDivs = document.querySelectorAll('.liquid.bg-white-liquid');
liquidDivs.forEach(div => {
  const imageWithTextDiv = div.querySelector('.image-with-text');
  if ((imageWithTextDiv && imageWithTextDiv.innerHTML.trim() === '') || div.innerHTML.trim() === '') {
    div.style.display = 'none';
  }
});

var currentPageURL = window.location.href;
if (currentPageURL.includes("over-40-green-wall-to-choose-from")) {
  var galleryButton = document.querySelector('.gallery_button');
  if (galleryButton) { galleryButton.setAttribute('target', '_blank'); }
}

function isMobileDevice() {
  return (typeof window.orientation !== "undefined") || (navigator.userAgent.indexOf('IEMobile') !== -1);
}

if (isMobileDevice()) {
  var list = document.querySelector('.footer__linklist');
  if (list) {
    var newListItem = document.createElement('li');
    var newLinkItem = document.createElement('a');
    newLinkItem.href = 'tel:+1 786 723 3309';
    newLinkItem.className = 'footer__link-item link';
    newLinkItem.textContent = 'Call Us: +1 786 723 3309';
    newListItem.appendChild(newLinkItem);
    list.appendChild(newListItem);
  }
}

/* ===== DP USA mobile header v2 A+: hide the search bar on scroll down, show on scroll up / page top / focus; magnifier icon in the top row while collapsed (phones only) ===== */
(function () {
  var mq = window.matchMedia('(max-width: 640px)');
  var root = document.documentElement;
  var last = 0, ticking = false, collapsed = false;
  var SVG = '<svg focusable="false" class="icon icon--search" viewBox="0 0 21 21" role="presentation"><g stroke-width="2" stroke="currentColor" fill="none" fill-rule="evenodd"><path d="M19 19l-5-5" stroke-linecap="square"></path><circle cx="8.5" cy="8.5" r="7.5"></circle></g></svg>';

  function wrapper() { return document.querySelector('.shopify-section__header .header__search-bar-wrapper'); }
  function setCollapsed(v) {
    if (v === collapsed) { return; }
    collapsed = v;
    root.classList.toggle('dp-search-collapsed', v);
    var b = document.querySelector('.dp-hdr-search__btn');
    if (b) { b.setAttribute('aria-hidden', v ? 'false' : 'true'); b.tabIndex = v ? 0 : -1; }
  }
  function prep() {
    var w = wrapper();
    if (!w) { return; }
    if (mq.matches) {
      var input = w.querySelector('.search-bar__input');
      if (input && input.getAttribute('placeholder') !== 'Search plants, green walls\u2026') {
        input.setAttribute('placeholder', 'Search plants, green walls\u2026');
        input.setAttribute('aria-label', 'Search plants, green walls');
      }
    }
    addButton();
  }
  function addButton() {
    if (document.querySelector('.dp-hdr-search')) { return; }
    var list = document.querySelector('.shopify-section__header .header__action-list');
    if (!list) { return; }
    var item = document.createElement('div');
    item.className = 'header__action-item dp-hdr-search';
    item.innerHTML = '<button type="button" class="dp-hdr-search__btn" aria-label="Search" aria-hidden="true" tabindex="-1">' + SVG + '</button>';
    list.insertBefore(item, list.firstChild);
    item.querySelector('button').addEventListener('click', openSearch);
  }
  // Tap on the magnifier: expand the header and focus the search input inside the same tap (keeps the phone keyboard opening).
  function openSearch(e) {
    if (e) { e.preventDefault(); }
    var w = wrapper();
    var input = w && w.querySelector('.search-bar__input');
    if (!input) { return; }
    root.classList.add('dp-search-opening');   // no transition: bar is visible/focusable immediately
    setCollapsed(false);
    void w.offsetHeight;                      // flush styles so visibility is already 'visible'
    try { input.focus({ preventScroll: true }); } catch (err) { input.focus(); }
    last = Math.max(0, window.pageYOffset || 0);
    window.setTimeout(function () { root.classList.remove('dp-search-opening'); }, 350);
  }
  function busy() {
    var w = wrapper();
    var inp = w && w.querySelector('.search-bar__input');
    if (inp && document.activeElement === inp) { return true; }           // typing / field focused
    if (inp && inp.value) { return true; }                                // field has text
    if (w && w.classList.contains('is-fixed')) { return true; }           // full-screen search open
    return !!document.querySelector('.header__mobile-nav-toggle[aria-expanded="true"]');
  }
  function update() {
    ticking = false;
    if (!mq.matches) { setCollapsed(false); return; }
    var y = Math.max(0, window.pageYOffset || 0);
    if (busy() || y <= 60) { setCollapsed(false); last = y; return; }
    var d = y - last;
    if (d > 8) { setCollapsed(true); last = y; }
    else if (d < -4) { setCollapsed(false); last = y; }
  }
  function onScroll() { if (!ticking) { ticking = true; window.requestAnimationFrame(update); } }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', function () { prep(); onScroll(); }, { passive: true });
  document.addEventListener('focusin', function (e) {
    var w = wrapper();
    if (w && w.contains(e.target)) { setCollapsed(false); last = Math.max(0, window.pageYOffset || 0); }
  });
  document.addEventListener('focusout', function () { last = Math.max(0, window.pageYOffset || 0); });
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', prep); } else { prep(); }
  window.addEventListener('load', prep);
  last = window.pageYOffset || 0;
})();
/* ===== /DP USA mobile header v2 A+ ===== */

/* ===== DP USA chat widget: hide while overlays open + lift above sticky Add to Cart (GHL) ===== */
(function () {
  'use strict';
  var root = document.documentElement;
  var mq = window.matchMedia('(max-width: 999px)');
  var pending = false;
  function isOpen(sel) { var e = document.querySelector(sel); return !!e && e.getAttribute('aria-hidden') === 'false'; }
  function update() {
    pending = false;
    var hide = isOpen('#mini-cart') ||
      (mq.matches && (isOpen('#mobile-menu') || isOpen('#mobile-collection-filters') || isOpen('.search-bar__results')));
    root.classList.toggle('dp-chat-hide', hide);
  }
  function schedule() { if (!pending) { pending = true; window.requestAnimationFrame(update); } }
  function watch() {
    if (!document.body) { return; }
    new MutationObserver(schedule).observe(document.body, { attributes: true, subtree: true, attributeFilter: ['aria-hidden'] });
    mq.addEventListener ? mq.addEventListener('change', schedule) : mq.addListener(schedule);
    update();
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', watch); } else { watch(); }

  /* Product pages: the real GHL bubble sits above the sticky Add to Cart bar (same 88px as the launcher).
     Style is injected into the widget's own (open) shadow root; position side (left/right) is NOT touched - that stays a GHL setting. */
  function lift() {
    var w = document.querySelector('chat-widget');
    if (!w) { return false; }
    var sr = w.shadowRoot;
    if (!sr || !sr.getElementById('lc_text-widget')) { window.setTimeout(lift, 400); return true; }
    if (document.body.classList.contains('template-product') && !sr.getElementById('dp-ghl-lift')) {
      var s = document.createElement('style'); s.id = 'dp-ghl-lift';
      s.textContent = '#lc_text-widget,#lc_text-widget--btn{bottom:88px !important}';
      sr.appendChild(s);
    }
    return true;
  }
  function waitForWidget() {
    if (!document.body || lift()) { return; }
    var mo = new MutationObserver(function () { if (lift()) { mo.disconnect(); } });
    mo.observe(document.body, { childList: true });
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', waitForWidget); } else { waitForWidget(); }
})();
/* ===== /DP USA chat widget ===== */

/* ===== DP USA chat widget v2: product-page clearance for sticky Add to Cart + Add-to-Cart buttons ===== */
(function () {
  'use strict';
  var root = document.documentElement;
  var AVOID = '[data-main-add-btn],[data-upsell-add-btn],[class*="add-btn"],form[action*="/cart/add"] [type="submit"],.dp-au-sticky__button';
  var pending = false, host = null, sr = null;
  function isProduct() { return !!document.body && document.body.classList.contains('template-product'); }
  function visRect(e) {
    var r = e.getBoundingClientRect();
    if (r.width < 2 || r.height < 2 || r.bottom <= 0 || r.top >= window.innerHeight) { return null; }
    var c = window.getComputedStyle(e);
    if (c.display === 'none' || c.visibility === 'hidden' || c.opacity === '0') { return null; }
    return r;
  }
  function bubbleRect() {
    var b = sr && sr.getElementById('lc_text-widget--btn');
    var r = b ? b.getBoundingClientRect() : null;
    if (!r || r.width < 2) { var f = document.getElementById('dp-chat-facade'); r = f ? f.getBoundingClientRect() : null; }
    return (r && r.width > 2) ? r : null;
  }
  function chatOpen() { var w = sr && sr.getElementById('lc_text-widget'); return !!w && w.classList.contains('lc_text-widget--active'); }
  function grab() {
    if (!host) { host = document.querySelector('chat-widget'); }
    if (host && !sr && host.shadowRoot) { sr = host.shadowRoot; }
    if (sr) {
      var old = sr.getElementById('dp-ghl-lift');          /* v1 fixed 88px rule: replaced by the dynamic one below */
      if (old) { old.parentNode.removeChild(old); }
      if (!sr.getElementById('dp-ghl-lift2')) {
        var s = document.createElement('style'); s.id = 'dp-ghl-lift2';
        s.textContent = ':host([data-dp-lift]) #lc_text-widget,:host([data-dp-lift]) #lc_text-widget--btn{bottom:var(--dp-chat-lift,88px) !important}';
        sr.appendChild(s);
      }
    }
  }
  function update() {
    pending = false;
    if (!isProduct()) { return; }
    grab();
    /* 1. lift above the sticky Add to Cart bar only while it is actually showing (uses its real height) */
    var bar = document.querySelector('.dp-au-sticky');
    var lift = 0;
    if (bar && bar.classList.contains('is-visible')) {
      var br = bar.getBoundingClientRect();
      if (br.height > 0 && br.top < window.innerHeight) { lift = Math.round(window.innerHeight - br.top + 16); }
    }
    if (lift) { root.style.setProperty('--dp-chat-lift', lift + 'px'); if (host) { host.setAttribute('data-dp-lift', ''); } }
    else { root.style.removeProperty('--dp-chat-lift'); if (host) { host.removeAttribute('data-dp-lift'); } }
    /* 2. fade the bubble out while it overlaps any other Add to Cart button (the Avada Joy rewards bubble gets the same treatment) */
    var els = document.querySelectorAll(AVOID);
    function overlapsAtc(b) {
      if (!b || b.width < 2) { return false; }
      for (var i = 0; i < els.length; i++) {
        if (bar && bar.contains(els[i])) { continue; }
        var r = visRect(els[i]), m = 10;
        if (r && r.left < b.right + m && r.right > b.left - m && r.top < b.bottom + m && r.bottom > b.top - m) { return true; }
      }
      return false;
    }
    root.classList.toggle('dp-chat-avoid', !chatOpen() && overlapsAtc(bubbleRect()));
    var joy = document.querySelector('.Avada-Joy_ButtonWidget');
    root.classList.toggle('dp-joy-avoid', !!joy && overlapsAtc(joy.getBoundingClientRect()));
  }
  function schedule() { if (!pending) { pending = true; window.requestAnimationFrame(update); } }
  function start() {
    if (!isProduct()) { return; }
    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule);
    document.addEventListener('transitionend', schedule, true);
    new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
    window.setInterval(schedule, 700);   /* catches GHL loading late / its panel opening */
    schedule();
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', start); } else { start(); }
})();
/* ===== /DP USA chat widget v2 ===== */

/* ===== DP USA gallery overlay focus trap (3 Nov 2026) ===== */
/* Covers the custom product lightbox ([data-lightbox], dp-product-* sections) and the theme's PhotoSwipe zoom (.pswp, main-product).
   While open: focus moves inside, Tab / Shift+Tab cycle inside, Escape closes, the rest of the page is inert + aria-hidden.
   On close: page restored and focus returns to the control that opened it. Runs only on open/close (no polling). */
(function () {
  'use strict';
  if (window.__dpOverlayTrap) return;
  window.__dpOverlayTrap = true;
  var OVERLAYS = '[data-lightbox], .pswp';
  var FOCUSABLE = 'a[href], area[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), iframe, [tabindex]:not([tabindex="-1"]), [contenteditable="true"]';
  var active = null;
  var lastPointer = null;

  function isOpen(el) { return el.matches('[data-lightbox]') ? el.classList.contains('is-open') : el.classList.contains('pswp--open'); }
  function shown(n) { if (!(n.offsetWidth || n.offsetHeight || n.getClientRects().length)) return false; var cs = getComputedStyle(n); return cs.visibility !== 'hidden' && cs.display !== 'none'; }
  function focusables(el) { return Array.prototype.filter.call(el.querySelectorAll(FOCUSABLE), shown); }
  function focusEl(n) { if (!n) return; try { n.focus({ preventScroll: true }); } catch (e) { n.focus(); } }
  function focusableOf(n) { return n && n.closest ? n.closest(FOCUSABLE) : null; }

  function isolate(el) {
    var changed = [];
    var node = el;
    while (node && node !== document.body && node.parentElement) {
      Array.prototype.forEach.call(node.parentElement.children, function (sib) {
        if (sib === node || /^(SCRIPT|STYLE|LINK|TEMPLATE)$/.test(sib.tagName)) return;
        var rec = { n: sib, inert: !sib.hasAttribute('inert'), ah: !sib.hasAttribute('aria-hidden') };
        if (rec.inert) sib.setAttribute('inert', '');
        if (rec.ah) sib.setAttribute('aria-hidden', 'true');
        if (rec.inert || rec.ah) changed.push(rec);
      });
      node = node.parentElement;
    }
    return changed;
  }
  function restore(changed) {
    changed.forEach(function (rec) {
      if (rec.inert) rec.n.removeAttribute('inert');
      if (rec.ah) rec.n.removeAttribute('aria-hidden');
    });
  }

  function pickTrigger(el) {
    var a = document.activeElement;
    if (a && a !== document.body && !el.contains(a) && a.matches(FOCUSABLE)) return a;
    var p = focusableOf(lastPointer);
    if (p && !el.contains(p)) return p;
    var scope = el.closest('.shopify-section') || document;
    var btn = scope.querySelector('[data-gallery-lightbox-open]');
    if (btn) return btn;
    return lastPointer && lastPointer.closest ? (lastPointer.closest('.dp-gallery, .product-gallery') || lastPointer) : null;
  }

  function onOpen(el) {
    if (active && active.el === el) return;
    if (active) onClose(active.el);
    var st = { el: el, trigger: pickTrigger(el), ahWas: el.getAttribute('aria-hidden'), modalWas: el.getAttribute('aria-modal'), tabWas: el.getAttribute('tabindex'), labelWas: el.getAttribute('aria-label') };
    el.setAttribute('aria-hidden', 'false');
    el.setAttribute('aria-modal', 'true');
    if (!el.getAttribute('role')) el.setAttribute('role', 'dialog');
    if (!el.getAttribute('aria-label') && !el.getAttribute('aria-labelledby')) el.setAttribute('aria-label', 'Product image gallery');
    if (st.tabWas === null) el.setAttribute('tabindex', '-1');
    st.changed = isolate(el);
    active = st;
    var first = el.querySelector('[data-lightbox-close], .pswp__button--close');
    if (!first || !shown(first)) first = focusables(el)[0] || el;
    focusEl(first);
  }

  function onClose(el) {
    if (!active || active.el !== el) return;
    var st = active;
    active = null;
    restore(st.changed);
    if (el.matches('.pswp')) el.setAttribute('aria-hidden', 'true');
    if (st.modalWas === null) el.removeAttribute('aria-modal');
    if (st.tabWas === null) el.removeAttribute('tabindex');
    if (st.labelWas === null && el.getAttribute('aria-label') === 'Product image gallery') el.removeAttribute('aria-label');
    var t = st.trigger;
    if (t && t.isConnected) {
      if (!t.matches(FOCUSABLE) && !t.hasAttribute('tabindex')) { t.setAttribute('tabindex', '-1'); t.addEventListener('blur', function rm() { t.removeAttribute('tabindex'); t.removeEventListener('blur', rm); }); }
      focusEl(t);
    }
  }

  function bind(el) {
    if (el.__dpTrap) return;
    el.__dpTrap = true;
    new MutationObserver(function () { if (isOpen(el)) onOpen(el); else onClose(el); }).observe(el, { attributes: true, attributeFilter: ['class'] });
    if (isOpen(el)) onOpen(el);
  }
  function scan() { Array.prototype.forEach.call(document.querySelectorAll(OVERLAYS), bind); }

  document.addEventListener('pointerdown', function (e) { lastPointer = e.target; scan(); }, true);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' || e.key === ' ') scan();
    if (!active) return;
    var el = active.el;
    if (e.key === 'Tab') {
      var list = focusables(el);
      if (!list.length) { e.preventDefault(); focusEl(el); return; }
      var i = list.indexOf(document.activeElement);
      if (e.shiftKey && (i <= 0)) { e.preventDefault(); focusEl(list[list.length - 1]); }
      else if (!e.shiftKey && (i === -1 || i === list.length - 1)) { e.preventDefault(); focusEl(list[0]); }
    } else if (e.key === 'Escape' || e.key === 'Esc') {
      setTimeout(function () {
        if (active && active.el === el && isOpen(el) && el.matches('[data-lightbox]')) {
          var c = el.querySelector('[data-lightbox-close]');
          if (c) c.click();
        }
      }, 0);
    }
  }, true);
  document.addEventListener('focusin', function (e) {
    if (active && !active.el.contains(e.target)) { var list = focusables(active.el); focusEl(list[0] || active.el); }
  }, true);
  document.addEventListener('shopify:section:load', scan);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan); else scan();
})();
/* ===== /DP USA gallery overlay focus trap ===== */
